import PageCommon from "../PageCommon.js";

export default class BlogPreview extends PageCommon {
	constructor() {
		super();

		this.blogPreview = document.querySelector(".blog-preview");

		this.imagesList = document.querySelector(".js-blog-images");
		this.imagesWrapper = document.querySelector(".js-blog-images-wrapper");
		this.textsList = document.querySelector(".js-blog-texts");
		this.textsWrapper = document.querySelector(".js-blog-texts-wrapper");

		this.imagesArray = Array.from(this.imagesList.querySelectorAll(".blog-img"));
		this.textsArray = Array.from(this.textsList.querySelectorAll(".single-text"));

		this.next = this.blogPreview.querySelector(".blog-next");
		this.prev = this.blogPreview.querySelector(".blog-prev");
	}
	init() {
		super.init();

		this.current = 0;

		const _this = this;
		if (this.next) {
			this.next.addEventListener("click", () => {
				_this.goNext();
			});
			if (this.imagesArray.length <= 1) {
				this.next.disabled = true;
			}
		}
		if (this.prev) {
			this.prev.addEventListener("click", () => {
				_this.goPrev();
			});
			this.prev.disabled = true;
		}

		if (this.imagesArray.length > 0) {
			const firstImage = this.imagesArray[this.current].querySelector("img");
			firstImage.addEventListener("load", function () {
				//Img loaded
				if (window.innerWidth > _this.maxWidthMobile) {
					_this.imagesList.style.width = `${_this.imagesArray[_this.current].querySelector("img").width}px`;
				}
				_this.imagesWrapper.style.width = `${_this.imagesArray[_this.current].querySelector("img").width * _this.imagesArray.length}px`;
				_this.imagesArray[_this.current].style.opacity = 1;
			});
			firstImage.src = firstImage.src;
			for (let index = 0; index < this.imagesArray.length; index++) {
				const span = document.createElement("span");
				if (index === 0) {
					span.classList.add("active");
				}
				document.querySelector(".blog-preview .navigation").appendChild(span);
			}
		}
	}

	goNext() {
		if (this.current < this.imagesArray.length) {
			this.current++;
			this.next.disabled = false;
			if (this.current > 0) {
				this.prev.disabled = false;
			}
			TweenMax.to(this.textsWrapper, 1, { y: -(this.current * 300) });
			TweenMax.to(this.imagesWrapper, 1, { x: -(this.current * this.imagesList.getBoundingClientRect().width + this.current * 30) });
			TweenMax.to(this.imagesArray[this.current - 1], 0, { opacity: 0, delay: 1 });
			this.imagesArray[this.current].style.opacity = 1;
		}
		if (this.current === this.imagesArray.length - 1) {
			this.next.disabled = true;
		}
		this.updateBullets();
	}

	goPrev() {
		if (this.current > 0) {
			this.current--;
			this.prev.disabled = false;
			if (this.current <= this.imagesArray.length) {
				this.next.disabled = false;
			}
			TweenMax.to(this.textsWrapper, 1, { y: -(this.current * 300) });
			TweenMax.to(this.imagesWrapper, 1, { x: -(this.current * this.imagesList.getBoundingClientRect().width + this.current * 30) });
			TweenMax.to(this.imagesArray[this.current + 1], 0, { opacity: 0, delay: 1 });
			this.imagesArray[this.current].style.opacity = 1;
		}
		if (this.current === 0) {
			this.prev.disabled = true;
		}
		this.updateBullets();
	}

	updateBullets() {
		const bullets = Array.from(document.querySelectorAll(".blog-preview .navigation span"));
		bullets.map((span, index) => {
			span.classList.remove("active");
			if (index === this.current) {
				span.classList.add("active");
			}
		});
	}
}
